function YogaIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.0964 25.6128C28.3662 25.8596 28.5 26.2571 28.5 27.1818C28.5 27.4424 28.252 28.1707 26.2705 28.8627C24.375 29.5247 21.2545 30 16.5 30C15.9477 30 15.5 30.4477 15.5 31C15.5 31.5523 15.9477 32 16.5 32C21.3462 32 24.7256 31.5207 26.93 30.7509C29.0483 30.0111 30.5 28.8303 30.5 27.1818C30.5 26.1974 30.3938 25.004 29.4465 24.1372C28.5434 23.3109 27.109 23 25.1116 23C24.4318 23 23.5216 23.1522 22.6013 23.3506C21.6602 23.5534 20.6328 23.8219 19.6875 24.0872C18.7405 24.3531 17.8664 24.6185 17.2296 24.8173C16.9109 24.9168 16.651 24.9998 16.4703 25.058C16.38 25.0872 16.3094 25.1101 16.2612 25.1259L16.2059 25.144L16.1865 25.1504C16.1864 25.1504 16.186 25.1506 16.5 26.1L16.1865 25.1504C15.6622 25.3238 15.3772 25.8896 15.5506 26.414C15.724 26.9383 16.2896 27.2228 16.8139 27.0494C16.814 27.0494 16.8139 27.0494 16.8139 27.0494L16.8306 27.0439L16.8825 27.0269C16.9284 27.0119 16.9965 26.9898 17.0842 26.9615C17.2597 26.9049 17.5136 26.8238 17.8255 26.7264C18.45 26.5315 19.3048 26.2719 20.228 26.0128C21.153 25.7531 22.1372 25.4966 23.0227 25.3057C23.9291 25.1103 24.6606 25 25.1116 25C27.0225 25 27.7824 25.3255 28.0964 25.6128Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.90361 25.6128C4.63383 25.8596 4.5 26.2571 4.5 27.1818C4.5 27.4424 4.74797 28.1707 6.72946 28.8627C8.62497 29.5247 11.7455 30 16.5 30C17.0523 30 17.5 30.4477 17.5 31C17.5 31.5523 17.0523 32 16.5 32C11.6538 32 8.27436 31.5207 6.07004 30.7509C3.95169 30.0111 2.5 28.8303 2.5 27.1818C2.5 26.1974 2.60617 25.004 3.55351 24.1372C4.45662 23.3109 5.89096 23 7.88845 23C8.56818 23 9.47842 23.1522 10.3987 23.3506C11.3398 23.5534 12.3672 23.8219 13.3125 24.0872C14.2595 24.3531 15.1336 24.6185 15.7704 24.8173C16.0891 24.9168 16.349 24.9998 16.5297 25.058C16.62 25.0872 16.6906 25.1101 16.7388 25.1259L16.7941 25.144L16.8135 25.1504C16.8136 25.1504 16.814 25.1506 16.5 26.1L16.8135 25.1504C17.3378 25.3238 17.6228 25.8896 17.4494 26.414C17.276 26.9383 16.7104 27.2228 16.1861 27.0494C16.186 27.0494 16.1861 27.0494 16.1861 27.0494L16.1694 27.0439L16.1175 27.0269C16.0716 27.0119 16.0035 26.9898 15.9158 26.9615C15.7403 26.9049 15.4864 26.8238 15.1745 26.7264C14.55 26.5315 13.6952 26.2719 12.772 26.0128C11.847 25.7531 10.8628 25.4966 9.97729 25.3057C9.07093 25.1103 8.33939 25 7.88845 25C5.97749 25 5.21761 25.3255 4.90361 25.6128Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.2932 10.825C13.3781 10.3477 13.793 10 14.2778 10H18.6333C19.1149 10 19.528 10.3432 19.6164 10.8165L21.483 20.8165C21.5376 21.1088 21.4592 21.4102 21.2693 21.6389C21.0793 21.8677 20.7974 22 20.5 22H12.5C12.2042 22 11.9235 21.869 11.7335 21.6422C11.5435 21.4155 11.4637 21.1162 11.5154 20.825L13.2932 10.825ZM15.1157 12L13.6935 20H19.2961L17.8027 12H15.1157Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5637 19.3511C24.71 19.7414 25.0832 20 25.5 20H29.5C30.0523 20 30.5 19.5523 30.5 19C30.5 18.4477 30.0523 18 29.5 18H26.193L23.4363 10.6489C23.29 10.2586 22.9168 10 22.5 10H18.5C17.9477 10 17.5 10.4477 17.5 11C17.5 11.5523 17.9477 12 18.5 12H21.807L24.5637 19.3511Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.43633 19.3511C8.28997 19.7414 7.91684 20 7.5 20H3.5C2.94771 20 2.5 19.5523 2.5 19C2.5 18.4477 2.94771 18 3.5 18H6.807L9.56367 10.6489C9.71003 10.2586 10.0832 10 10.5 10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H11.193L8.43633 19.3511Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.5 6C17.6046 6 18.5 5.10457 18.5 4C18.5 2.89543 17.6046 2 16.5 2C15.3954 2 14.5 2.89543 14.5 4C14.5 5.10457 15.3954 6 16.5 6ZM16.5 8C18.7091 8 20.5 6.20914 20.5 4C20.5 1.79086 18.7091 0 16.5 0C14.2909 0 12.5 1.79086 12.5 4C12.5 6.20914 14.2909 8 16.5 8Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default YogaIcon;
